/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class MapToSystemStatusAndStatesModel {
        private systemLevel: Wars.Domain.Model.SystemLevel;
        private processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        private confirmChangeOfSystemCodeGroup: boolean;
        private systemStatusCodeGroupId: string;
        private isReadonly: boolean;

        constructor(
            private processConfigId: string,
            private processConfigurationService: services.ProcessConfigurationService,
            private systemLevelService: services.SystemLevelService)
        {

            this.systemLevelService.getSystemLevelStatusesAndStates().then((systemLevel) => {
                this.systemLevel = systemLevel;
                this.processConfigurationService.loadProcessConfigurationStatusGroup(processConfigId).then((processConfig) => {
                    this.processConfiguration = processConfig;
                    this.processConfiguration.systemStatusCodeGroup_id = systemLevel.statusCodeGroup_id;

                    this.systemStatusCodeGroupId = this.processConfiguration.systemStatusCodeGroup_id;
                    this.isReadonly = this.processConfiguration.minorVersion !== null;
                });
            });
            
            this.confirmChangeOfSystemCodeGroup = false;
        }

        public clearAllConnections(): void {
            var statusCount = this.processConfiguration.myStatusCodeGroup === null ? 0 : this.processConfiguration.myStatusCodeGroup.myStatuses.length;
            for (var statusIndex = 0; statusIndex < statusCount; statusIndex++) {
                var currentStatus = this.processConfiguration.myStatusCodeGroup.myStatuses[statusCount];
                currentStatus.systemStatusCode_id = null;
                currentStatus.mySystemStatusCode = null;

                var stateCount = currentStatus.myStates.length;
                for (var stateIndex = 0; stateIndex < stateCount; stateIndex++) {
                    var currentState = currentStatus.myStates[stateIndex];
                    currentState.systemStateCode_id = null;
                    currentState.mySystemStateCode = null;
                }
            }
        }
        


        public save() {
            this.processConfigurationService.saveAllChanges();
        }
    }
}
